import { Form } from '@/helpers/fs/form'
import { isEmpty, isNull } from 'es-toolkit/compat'
import { defineStore } from 'pinia'
import { useTeamStore } from './teamStore'

type State = {
  forms: Form[]
  isLoading: boolean
}
export const useFormsStore = defineStore('forms', {
  state: (): State => {
    return {
      forms: [],
      isLoading: true
    }
  },
  actions: {
    async setup() {
      const currentTeamId = useTeamStore().currentTeamId
      if (isNull(currentTeamId)) return
      this.forms = await Form.builds(currentTeamId)
      this.isLoading = false
    }
  },
  getters: {
    hasNoForm(state): boolean {
      return !state.isLoading && isEmpty(state.forms)
    }
  }
})
